import { ReactNode } from 'react';
import { EMPTY_STATES } from '../constants';

interface ChartLoadingProps {
  fillParent?: boolean;
  className?: string;
}

export function ChartLoading({
  fillParent = false,
  className = '',
}: ChartLoadingProps) {
  const heightClass = fillParent ? 'h-full' : '';

  return (
    <div
      className={`flex items-center justify-center ${heightClass} ${className}`}
    >
      <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-blue-600"></div>
    </div>
  );
}

interface ChartErrorProps {
  error: string;
  fillParent?: boolean;
  className?: string;
}

export function ChartError({
  error,
  fillParent = false,
  className = '',
}: ChartErrorProps) {
  const heightClass = fillParent ? 'h-full' : '';

  return (
    <div
      className={`flex items-center justify-center ${heightClass} ${className}`}
    >
      <div className="text-center">
        <svg
          className="mx-auto mb-2 h-8 w-8 text-red-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <p className="text-sm text-red-600">{error}</p>
      </div>
    </div>
  );
}

interface ChartEmptyProps {
  message?: string;
  fillParent?: boolean;
  className?: string;
  children?: ReactNode;
}

export function ChartEmpty({
  message = EMPTY_STATES.noData,
  fillParent = false,
  className = '',
  children,
}: ChartEmptyProps) {
  const heightClass = fillParent ? 'h-full' : '';

  if (children) {
    return (
      <div
        className={`flex items-center justify-center ${heightClass} ${className}`}
      >
        {children}
      </div>
    );
  }

  return (
    <div
      className={`flex items-center justify-center ${heightClass} ${className}`}
    >
      <div className="text-center">
        <svg
          className="text-base-400 mx-auto mb-2 h-8 w-8"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
          />
        </svg>
        <p className="text-base-500 text-sm">{message}</p>
      </div>
    </div>
  );
}
